import { render, staticRenderFns } from "./AnnounceTrialEnded.vue?vue&type=template&id=243f026c&scoped=true"
import script from "./AnnounceTrialEnded.vue?vue&type=script&lang=js"
export * from "./AnnounceTrialEnded.vue?vue&type=script&lang=js"
import style0 from "./AnnounceTrialEnded.vue?vue&type=style&index=0&id=243f026c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243f026c",
  null
  
)

export default component.exports